import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit {

  @Input() menuList: Array<any>;
  @Input() linkId: string;
  constructor(
    private route: ActivatedRoute,
    private router: Router) {
  }

  ngOnInit() {
  }

  public isCurrentPage(title: string) {
    const url = window.location.href.toString();

    if (url.includes(title)) {
      return true;
    }
    return false;
  }

  public load(link) {
    this.router.navigate([link], {relativeTo: this.route});
  }

}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/modules/header/navigation/navigation.component.ts